import { Route, Switch } from "react-router-dom";
import { NotFoundPage } from "pages/service";
import { MainPage } from "./main";
import { Events } from "./inspevents";
import { AddInspector } from "./addinspector";
import { EditInspector } from "./editinspector";
import { AddEvent } from "./addevent";
import { AllEvents } from "./events";
import { EditEvent } from "./editevent";

export function Pages() {

    return (
        <div
            style={{
                margin: "10px",
            }}
        >
            <Switch>
                <Route path="/inspector/:ID">
                    <Events />
                </Route>
                <Route path="/add/inspector">
                    <AddInspector />
                </Route>
                <Route path="/edit/inspector/:ID">
                    <EditInspector />
                </Route>
                <Route path="/add/event">
                    <AddEvent />
                </Route>
                <Route path="/all/events">
                    <AllEvents />
                </Route>
                <Route path="/edit/event">
                    <EditEvent />
                </Route>
                <Route path="/:any">
                    <NotFoundPage />
                </Route>
                <Route path="/">
                    <MainPage />
                </Route>

            </Switch>
        </div>
    );
}